
















import { Component, Vue, Prop } from "vue-property-decorator";
import { GListOption } from "shared/global/types";
import {
  ExtendedProjectModel,
  EProjectType,
  EManagementFeeType,
} from "../models";
import dateflip from "shared/filters/dateflip";
import money from "shared/filters/money";

@Component({
  filters: { dateflip, money },
})
export default class ProjectInfo extends Vue {
  @Prop({ required: true, type: Object }) private value!: ExtendedProjectModel;

  get isRenting(): boolean {
    return this.value.project_type === EProjectType.renting;
  }

  get isManagement(): boolean {
    return this.value.project_type === EProjectType.management;
  }

  get objectDataList(): GListOption[] {
    const list = [
      { label: this.t("description"), value: this.value.description },
    ];
    if (this.isRenting) {
      list.push(
        {
          label: this.t("numberOfBedrooms"),
          value: String(this.value.number_of_bedrooms),
        },
        {
          label: this.t("numberOfPersons"),
          value: String(this.value.number_of_persons),
        }
      );
    }
    if (this.isManagement) {
      const label =
        String(this.value.energy_label) !== ""
          ? String(this.value.energy_label)
          : this.$t("houseprojects.terms.unknown").toString();
      const experiationDate =
        String(this.value.energy_label_expiration_date) !== ""
          ? ", " +
            this.t("expires") +
            ": " +
            this.$options.filters!.dateflip(
              String(this.value.energy_label_expiration_date)
            )
          : "";

      list.push(
        {
          label: this.t("offerType"),
          value: String(this.value.offer_type),
        },
        {
          label: this.t("energyLabel"),
          value: label + experiationDate,
        }
      );
    }
    return list;
  }

  get hiringDataList(): GListOption[] {
    if (this.value.hiring_data === undefined) return [];
    return [
      {
        label: this.t("startDate"),
        value: this.$options.filters!.dateflip(
          this.value.hiring_data.start_date
        ),
      },
      {
        label: this.t("minimalDuration"),
        value: this.value.hiring_data.minimal_duration,
      },
      { label: this.t("notice"), value: this.value.hiring_data.notice },
    ];
  }

  get managementDataList(): GListOption[] {
    if (this.value.management_data === undefined) return [];
    const res = [
      {
        label: this.t("managementType"),
        value: this.value.management_data.management_type,
      },
    ];

    if (
      this.value.management_data.management_fee_type ===
      EManagementFeeType.fixed_fee
    ) {
      res.push({
        label: this.t("managementFee"),
        value: this.$options.filters!.money(
          this.value.management_data.management_fee
        ),
      });
    } else if (
      this.value.management_data.management_fee_type ===
      EManagementFeeType.percentage
    ) {
      res.push({
        label: this.t("managementFee"),
        value: String(this.value.management_data.management_fee) + "%",
      });
    }
    return res;
  }

  get heatingList(): GListOption[] {
    const unknown = this.$t("houseprojects.terms.unknown").toString();
    return [
      {
        label: this.t("heatingType"),
        value:
          this.value.heating.heating_type === ""
            ? unknown
            : this.value.heating.heating_type,
      },
      {
        label: this.t("constructionYear"),
        value:
          this.value.heating.construction_year === 0
            ? unknown
            : String(this.value.heating.construction_year),
      },
      {
        label: this.t("lastBoilerMaintenanceTechnician"),
        value:
          this.value.heating.last_boiler_maintenance_technician === ""
            ? unknown
            : this.value.heating.last_boiler_maintenance_technician,
      },
    ];
  }

  t(key: string): string {
    return this.$t("houseprojects.projectInfo." + key).toString();
  }
}
